export default __webpack_public_path__ + "static/media/elipses.ae100b3c.svg";